import PropTypes from 'prop-types';
import React from 'react';

const ThailandSpeceficHeader = ({ returnedItems, contactDetails }) => {
  const details = contactDetails.find((name) => name.Name?.FullName);
  return (
    <>
      {!!returnedItems.length && (
      <p>Credit Note</p>
      )}
      {!returnedItems.length && (
      <p>{!details?.Name?.FullName ? 'Tax Invoice (ABB)' : 'Tax Invoice'}</p>
      )}
    </>
  );
};

ThailandSpeceficHeader.defaultProps = {
  contactDetails: {},
  returnedItems: [],
};

ThailandSpeceficHeader.propTypes = {
  contactDetails: PropTypes.arrayOf(PropTypes.shape()),
  returnedItems: PropTypes.arrayOf(PropTypes.shape()),
};

export default ThailandSpeceficHeader;
